import type { DynamicFieldsOptionType } from "Pages/ImportWizard/model";
import { atom } from "recoil";
import type { GetDefaultMappingResponse } from "Types/beRecipientsApi";

export const dynamicFieldsOptionState = atom<DynamicFieldsOptionType[]>({
  key: "ImportFile_dynamicFieldsOptionState",
  default: [],
});

export const defaultMappingState = atom<GetDefaultMappingResponse>({
  key: "ImportFile_defaultMappingState",
  default: { Items: [] },
});
